// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../pages/TelerecoveryServices/resources/attach_image.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../pages/TelerecoveryServices/resources/send.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../pages/TelerecoveryServices/resources/send_disabled.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Telerecovery_wrapper__qsYfh {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 15px;
}

.Telerecovery_sidebar__P7bxd {
  padding: 30px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.Telerecovery_sidebar__P7bxd h2 {
  margin-top: 0;
  font-size: 1.2rem;
}

.Telerecovery_telerecoveryContent__lZSHI {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.Telerecovery_chatMessageBody__Hi8a4 {
  margin-bottom: 20px;
  width: fit-content;
}

.Telerecovery_myMessage__wb3um,
.Telerecovery_staffMessage__0ADPs {
  color: #383838;
  padding: 8px 10px;
  font-size: 1rem;
  text-align: left;
  width: fit-content;
  margin-bottom: 3px;
  max-width: 85%;
}

.Telerecovery_myMessage__wb3um {
  background: #e7e0f14d;
  border-radius: 8px;
  border-top-right-radius: 0px;
  float: right;
  clear: right;
}

.Telerecovery_staffMessage__0ADPs {
  background: #debeed80;
  border-radius: 8px;
  border-top-left-radius: 0px;
}

.Telerecovery_messageData__qezQA {
  color: #383838;
  font-size: 12px;
  display: flex;
  gap: 6px;
  width: 100%;
}

.Telerecovery_messageDataTime__L2vZk {
  color: #888888;
  margin-left: 15px;
}

.Telerecovery_chatHistoryContainer__srgxo {
  overflow: auto;
  /* height: 430px; */
  height: calc(100vh - 490px);
  padding-right: 10px;
  text-align: center;
  padding-top: 10px;
  margin-top: 10px;
}

.Telerecovery_chatHistoryContainer__srgxo::-webkit-scrollbar {
  width: 10px;
}

.Telerecovery_chatHistoryContainer__srgxo::-webkit-scrollbar-track {
  background-color: white;
}

.Telerecovery_chatHistoryContainer__srgxo::-webkit-scrollbar-thumb {
  background-color: lightgray;
  border-radius: 25px;
}

.Telerecovery_newMessageBox__mtmKg {
  border: 1px solid var(--branded-light-purple);
  color: #383838;
  font-size: 12px;
  width: 100%;
}

.Telerecovery_mms_file_upload_btn__opKs- {
  background-position: center !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background-repeat: no-repeat !important;
  background-color: transparent;
  border: none !important;
}

.Telerecovery_sendBtn__b0Ddl {
  background-position: center !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-repeat: no-repeat !important;
  background-color: transparent;
  border: none !important;
  scale: 1.5;
}

.Telerecovery_sendBtn__b0Ddl:hover {
  background-color: transparent !important;
  border: none !;
}

.Telerecovery_sendBtn__b0Ddl:disabled {
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  border: none !;
}

.Telerecovery_chatWindowHeader__fvgk4 {
  color: #383838;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  border-bottom: solid 2px;
  border-color: var(--branded-light-purple);
}

.Telerecovery_userInitials__7dA72 {
  border-radius: 100px;
  line-height: 37px;
  display: inline-block;
  text-align: center;
  font-size: 13.5px;
  width: 37px;
  height: 37px;
  background-color: #debeed80;
  color: var(--branded-purple);
  margin-right: 3px;
  font-weight: 700;
}

.Telerecovery_unreadMessagesCount__mw9Tx {
  border-radius: 100px;
  width: 8px;
  height: 8px;
  background-color: var(--branded-purple);
  margin-top: 5px;
  margin-right: 1px;
}

.Telerecovery_chatWindowFooter__5l451 {
  margin-top: 10px;
  display: flex;
  width: 100%;
  gap: 9px;
}

.Telerecovery_chatWindowList__kWlnD {
  list-style: none;
  overflow: hidden;
  padding-left: 8px;
}

.Telerecovery_convEmptyMsg__rahY3 {
  color: #383838;
  margin-top: 100px;
  display: block;
}

.Telerecovery_chatConvMenu__j29jw {
  overflow-y: auto;
  /* width: 300px; */
  /* height: 629px; */
  height: calc(100vh - 300px);
  border-radius: 16px;
  padding: 15px;
}

.Telerecovery_chatComponent__SaInM {
  background-color: #e7e0f180;
  border-radius: 20px;
  padding: 26px;
  padding-bottom: 27px;
  height: calc(100vh - 300px);
}

.Telerecovery_chatConvElement__QoPAa {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 3px;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: -1px;
  margin-top: -1px;
}

.Telerecovery_chatConvElement__QoPAa:hover {
  background: #e7e0f1;
}

.Telerecovery_chatConvElementSelected__1lIxM {
  background: var(--branded-light-purple) 80;
}

.Telerecovery_chatConvElement__QoPAa p {
  text-align: left;
  font-size: 12px;
}

.Telerecovery_unread__r361X {
  width: 6px;
  height: 6px;
  border-radius: 100px;
  background: var(--branded-purple);
  position: absolute;
  right: 10px;
  top: 22px;
}

.Telerecovery_chatWindow__3ftUT {
  padding: 20px;
  background-color: white;
  border-radius: 12px;
  height: 100%;
}

.Telerecovery_mms__fixxK img {
  border-radius: 8px !important;
  border: 1px solid var(--branded-light-purple) 80;
}

.Telerecovery_mms_file_upload__ItEdK {
  height: 36px;
  width: 30px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding-top: 6px;
}

.Telerecovery_mms_file_upload_disabled__DfpPb {
  background-color: #cccccca3;
}

.Telerecovery_mms_file_upload__ItEdK .p-fileupload-content {
  display: none !important;
}

.Telerecovery_mms_file_upload__ItEdK .p-fileupload-choose {
  margin: 0 !important;
  width: 24px !important;
  height: 24px !important;
  color: var(--branded-purple) !important;
  background-color: transparent !important;
  border: none !important;
  scale: 1.3;
}

.Telerecovery_mms_file_upload__ItEdK .p-fileupload-choose:hover {
  margin: 0 !important;
  background-color: transparent !important;
  border: none !important;
  color: var(--branded-purple) !important;
}

.Telerecovery_mms_file_upload__ItEdK .p-fileupload-buttonbar {
  padding-left: 3px !important;
  background-color: transparent !important;
  margin: 0 !important;
  border: none !important;
}

.Telerecovery_mms_preview_container__Rmwwp {
  margin-top: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.Telerecovery_mms_preview_container__Rmwwp button {
  width: 24px !important;
  height: 24px !important;
  background-color: transparent !important;
  color: var(--branded-purple) !important;
  border: none !important;
}

.Telerecovery_link__IoNPz {
  font-weight: 600;
  font-size: 13px;
  color: #999999;
  text-decoration: underline;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Telerecovery_link__IoNPz:hover {
  cursor: pointer;
}

.Telerecovery_buttons__SC7tt {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.Telerecovery_button__M3hzU {
  width: fit-content !important;
  border-radius: 28px;
  font-weight: 600;
  font-size: 13px !important;
  min-width: 92px;
}

.Telerecovery_cancel_button__LQp1u {
  font-weight: 600;
  font-size: 13px !important;
  width: fit-content !important;
  background-color: transparent;
  padding: 10px 20px;
  border-radius: 28px;
  color: var(--branded-purple);
  border-color: var(--branded-purple);
  min-width: 92px !important;
  justify-content: center;
}

.Telerecovery_lastMessage_text__I2yPv {
  font-size: "11px";
  align-self: "center";
}

@media (max-width: 767px) {
  .Telerecovery_lastMessage_text__I2yPv {
    width: 70px !important;
    font-size: 10px !important;
  }

  .Telerecovery_myMessage__wb3um,
  .Telerecovery_staffMessage__0ADPs {
    font-size: 12px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Telerecovery.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,oEAA4F;EAC5F,uCAAuC;EACvC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,oEAAoF;EACpF,uCAAuC;EACvC,6BAA6B;EAC7B,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,oEAA6F;EAC7F,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,uCAAuC;EACvC,wCAAwC;EACxC,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;EACxC,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wCAAwC;EACxC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":[".wrapper {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  gap: 15px;\n}\n\n.sidebar {\n  padding: 30px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.sidebar h2 {\n  margin-top: 0;\n  font-size: 1.2rem;\n}\n\n.telerecoveryContent {\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n}\n\n.chatMessageBody {\n  margin-bottom: 20px;\n  width: fit-content;\n}\n\n.myMessage,\n.staffMessage {\n  color: #383838;\n  padding: 8px 10px;\n  font-size: 1rem;\n  text-align: left;\n  width: fit-content;\n  margin-bottom: 3px;\n  max-width: 85%;\n}\n\n.myMessage {\n  background: #e7e0f14d;\n  border-radius: 8px;\n  border-top-right-radius: 0px;\n  float: right;\n  clear: right;\n}\n\n.staffMessage {\n  background: #debeed80;\n  border-radius: 8px;\n  border-top-left-radius: 0px;\n}\n\n.messageData {\n  color: #383838;\n  font-size: 12px;\n  display: flex;\n  gap: 6px;\n  width: 100%;\n}\n\n.messageDataTime {\n  color: #888888;\n  margin-left: 15px;\n}\n\n.chatHistoryContainer {\n  overflow: auto;\n  /* height: 430px; */\n  height: calc(100vh - 490px);\n  padding-right: 10px;\n  text-align: center;\n  padding-top: 10px;\n  margin-top: 10px;\n}\n\n.chatHistoryContainer::-webkit-scrollbar {\n  width: 10px;\n}\n\n.chatHistoryContainer::-webkit-scrollbar-track {\n  background-color: white;\n}\n\n.chatHistoryContainer::-webkit-scrollbar-thumb {\n  background-color: lightgray;\n  border-radius: 25px;\n}\n\n.newMessageBox {\n  border: 1px solid var(--branded-light-purple);\n  color: #383838;\n  font-size: 12px;\n  width: 100%;\n}\n\n.mms_file_upload_btn {\n  background-position: center !important;\n  background-image: url(\"../pages/TelerecoveryServices/resources/attach_image.svg\") !important;\n  background-repeat: no-repeat !important;\n  background-color: transparent;\n  border: none !important;\n}\n\n.sendBtn {\n  background-position: center !important;\n  background-image: url(\"../pages/TelerecoveryServices/resources/send.svg\") !important;\n  background-repeat: no-repeat !important;\n  background-color: transparent;\n  border: none !important;\n  scale: 1.5;\n}\n\n.sendBtn:hover {\n  background-color: transparent !important;\n  border: none !;\n}\n\n.sendBtn:disabled {\n  background-color: transparent;\n  background-image: url(\"../pages/TelerecoveryServices/resources/send_disabled.svg\") !important;\n  border: none !;\n}\n\n.chatWindowHeader {\n  color: #383838;\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: solid 2px;\n  border-color: var(--branded-light-purple);\n}\n\n.userInitials {\n  border-radius: 100px;\n  line-height: 37px;\n  display: inline-block;\n  text-align: center;\n  font-size: 13.5px;\n  width: 37px;\n  height: 37px;\n  background-color: #debeed80;\n  color: var(--branded-purple);\n  margin-right: 3px;\n  font-weight: 700;\n}\n\n.unreadMessagesCount {\n  border-radius: 100px;\n  width: 8px;\n  height: 8px;\n  background-color: var(--branded-purple);\n  margin-top: 5px;\n  margin-right: 1px;\n}\n\n.chatWindowFooter {\n  margin-top: 10px;\n  display: flex;\n  width: 100%;\n  gap: 9px;\n}\n\n.chatWindowList {\n  list-style: none;\n  overflow: hidden;\n  padding-left: 8px;\n}\n\n.convEmptyMsg {\n  color: #383838;\n  margin-top: 100px;\n  display: block;\n}\n\n.chatConvMenu {\n  overflow-y: auto;\n  /* width: 300px; */\n  /* height: 629px; */\n  height: calc(100vh - 300px);\n  border-radius: 16px;\n  padding: 15px;\n}\n\n.chatComponent {\n  background-color: #e7e0f180;\n  border-radius: 20px;\n  padding: 26px;\n  padding-bottom: 27px;\n  height: calc(100vh - 300px);\n}\n\n.chatConvElement {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 3px;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: -1px;\n  margin-top: -1px;\n}\n\n.chatConvElement:hover {\n  background: #e7e0f1;\n}\n\n.chatConvElementSelected {\n  background: var(--branded-light-purple) 80;\n}\n\n.chatConvElement p {\n  text-align: left;\n  font-size: 12px;\n}\n\n.unread {\n  width: 6px;\n  height: 6px;\n  border-radius: 100px;\n  background: var(--branded-purple);\n  position: absolute;\n  right: 10px;\n  top: 22px;\n}\n\n.chatWindow {\n  padding: 20px;\n  background-color: white;\n  border-radius: 12px;\n  height: 100%;\n}\n\n.mms img {\n  border-radius: 8px !important;\n  border: 1px solid var(--branded-light-purple) 80;\n}\n\n.mms_file_upload {\n  height: 36px;\n  width: 30px;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  padding-top: 6px;\n}\n\n.mms_file_upload_disabled {\n  background-color: #cccccca3;\n}\n\n.mms_file_upload :global(.p-fileupload-content) {\n  display: none !important;\n}\n\n.mms_file_upload :global(.p-fileupload-choose) {\n  margin: 0 !important;\n  width: 24px !important;\n  height: 24px !important;\n  color: var(--branded-purple) !important;\n  background-color: transparent !important;\n  border: none !important;\n  scale: 1.3;\n}\n\n.mms_file_upload :global(.p-fileupload-choose:hover) {\n  margin: 0 !important;\n  background-color: transparent !important;\n  border: none !important;\n  color: var(--branded-purple) !important;\n}\n\n.mms_file_upload :global(.p-fileupload-buttonbar) {\n  padding-left: 3px !important;\n  background-color: transparent !important;\n  margin: 0 !important;\n  border: none !important;\n}\n\n.mms_preview_container {\n  margin-top: 5px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.mms_preview_container button {\n  width: 24px !important;\n  height: 24px !important;\n  background-color: transparent !important;\n  color: var(--branded-purple) !important;\n  border: none !important;\n}\n\n.link {\n  font-weight: 600;\n  font-size: 13px;\n  color: #999999;\n  text-decoration: underline;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.link:hover {\n  cursor: pointer;\n}\n\n.buttons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.button {\n  width: fit-content !important;\n  border-radius: 28px;\n  font-weight: 600;\n  font-size: 13px !important;\n  min-width: 92px;\n}\n\n.cancel_button {\n  font-weight: 600;\n  font-size: 13px !important;\n  width: fit-content !important;\n  background-color: transparent;\n  padding: 10px 20px;\n  border-radius: 28px;\n  color: var(--branded-purple);\n  border-color: var(--branded-purple);\n  min-width: 92px !important;\n  justify-content: center;\n}\n\n.lastMessage_text {\n  font-size: \"11px\";\n  align-self: \"center\";\n}\n\n@media (max-width: 767px) {\n  .lastMessage_text {\n    width: 70px !important;\n    font-size: 10px !important;\n  }\n\n  .myMessage,\n  .staffMessage {\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Telerecovery_wrapper__qsYfh`,
	"sidebar": `Telerecovery_sidebar__P7bxd`,
	"telerecoveryContent": `Telerecovery_telerecoveryContent__lZSHI`,
	"chatMessageBody": `Telerecovery_chatMessageBody__Hi8a4`,
	"myMessage": `Telerecovery_myMessage__wb3um`,
	"staffMessage": `Telerecovery_staffMessage__0ADPs`,
	"messageData": `Telerecovery_messageData__qezQA`,
	"messageDataTime": `Telerecovery_messageDataTime__L2vZk`,
	"chatHistoryContainer": `Telerecovery_chatHistoryContainer__srgxo`,
	"newMessageBox": `Telerecovery_newMessageBox__mtmKg`,
	"mms_file_upload_btn": `Telerecovery_mms_file_upload_btn__opKs-`,
	"sendBtn": `Telerecovery_sendBtn__b0Ddl`,
	"chatWindowHeader": `Telerecovery_chatWindowHeader__fvgk4`,
	"userInitials": `Telerecovery_userInitials__7dA72`,
	"unreadMessagesCount": `Telerecovery_unreadMessagesCount__mw9Tx`,
	"chatWindowFooter": `Telerecovery_chatWindowFooter__5l451`,
	"chatWindowList": `Telerecovery_chatWindowList__kWlnD`,
	"convEmptyMsg": `Telerecovery_convEmptyMsg__rahY3`,
	"chatConvMenu": `Telerecovery_chatConvMenu__j29jw`,
	"chatComponent": `Telerecovery_chatComponent__SaInM`,
	"chatConvElement": `Telerecovery_chatConvElement__QoPAa`,
	"chatConvElementSelected": `Telerecovery_chatConvElementSelected__1lIxM`,
	"unread": `Telerecovery_unread__r361X`,
	"chatWindow": `Telerecovery_chatWindow__3ftUT`,
	"mms": `Telerecovery_mms__fixxK`,
	"mms_file_upload": `Telerecovery_mms_file_upload__ItEdK`,
	"mms_file_upload_disabled": `Telerecovery_mms_file_upload_disabled__DfpPb`,
	"mms_preview_container": `Telerecovery_mms_preview_container__Rmwwp`,
	"link": `Telerecovery_link__IoNPz`,
	"buttons": `Telerecovery_buttons__SC7tt`,
	"button": `Telerecovery_button__M3hzU`,
	"cancel_button": `Telerecovery_cancel_button__LQp1u`,
	"lastMessage_text": `Telerecovery_lastMessage_text__I2yPv`
};
export default ___CSS_LOADER_EXPORT___;
